<template>
  <div class="ang-card">
    <form class="ang-card-body" method="POST" action="/clients/code" id="smsForm" ref="smsForm">
        <div class="row">
            <div class="col-12">
                <p class="pb-4 m-0">Na Twój numer telefonu wysłaliśmy wiadomość SMS z kodem
                    służącym do potwierdzenia Twoich wiadomości i Twoich zgód. Nie martw się jeżeli
                    nie otrzymasz wiadomości SMS - ten sam kod wysłaliśmy Tobie w wiadomości
                    e-mail.</p>
                <div class="alert alert-warning ang-alert-warning mb-3" role="alert" >
                    <h5 class="ang-card-title">Uwaga!</h5>
                    Masz tylko <span style="font-weight: 700">15 minut</span> na potwierdzenie
                    swoich danych. Jeżeli w ciągu 15 minut nie potwierdzisz swoich danych zostaną
                    one skasowane z naszych baz danych.
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label class="ang-form-label" for="email_code_confirmation">Adres e-mail</label>
                    <input type="email" class="ang-form-control" id="email_code_confirmation"
                           name="email_code_confirmation" v-model="client.email" required>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label class="ang-form-label" for="code">Kod potwierdzający</label>
                    <input type="text" class="ang-form-control" id="code" name="code" v-model="code" required>
                </div>
            </div>
        </div>
        <div class="alert alert-danger ang-alert-danger mt-3" v-if="error">
            <h5 class="ang-card-title">Wystąpił błąd!</h5>
            <label class="form-error error">{{error}}</label>
        </div>
        <div class="d-flex justify-content-between">
            <div class="mt-3 form-return pr-4" v-if="!sending" @click="returnToForm">Wróć do formularza
                rejestracji
            </div>
          <spinner v-if="sending"></spinner>
          <div class="d-flex align-items-center">
            <button type="submit" class="btn btn-lg  ang-btn-lg ang-button mt-1" v-if="!sending">Potwierdź</button>
          </div>
        </div>
    </form>
    <div class="deco-4">
      <div class="parallax-scene">
        <svg class="parallax-move" data-depth="0.4" height="226.12" viewBox="0 0 222.922 226.12"
             width="222.922" xmlns="http://www.w3.org/2000/svg">
          <path d="M152.318 155.231c-8.283 6.18-21.242 2.146-37.635-3.187-25.472-8.286-23.941-14.048-35.653-14.508-20.199-.793-26.436 16.274-46.978 13.665-2.8-.356-15.594-1.979-20.159-10.578-7.85-14.792 11.33-45.223 36.242-55.391 12.282-5.014 23.97-4.294 44.123-3.05 27.015 1.667 35.371 7.761 46.188 1.495 13.407-7.766 9.779-22.462 20.207-26.726 19.37-7.923 60.748 30.97 54.278 48.263-5.292 14.117-39.544 5.884-51.77 28.451-5.162 9.53-2.022 16.48-8.843 21.566z"
                fill="#11A68A"></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import ajax from '@/services/ajax'
import spinner from "@/components/partials/misc/spinner"
import $ from 'jquery'

export default {
  data () {
    return {
      code: '',
      error: null,
      sending: false
    }
  },
  props: ['client', 'base', 'solicitor'],
  components: {
    spinner
  },
  name: 'smsForm',
  mounted () {
    let self = this
    ajax.postValidate($(self.$refs.smsForm), self, function () {
      self.$emit('code', self.code)
      self.success = true
    }, function (data) {
      self.error = data.message
      self.sending = false
    }, function () {
      self.error = null
      self.sending = true
    })
  },
  methods: {
    returnToForm () {
      this.$emit('return')
    }
  }

}
</script>

